import { withStyles } from "@material-ui/core/styles";
import MuiDialogContent from "@material-ui/core/DialogContent";

export const DialogContent = withStyles(theme => ({
  root: {
    overflowY: 'hidden'
  }
}))(MuiDialogContent);

export const DialogContentWithCards = withStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    overflowY: 'hidden'
  }
}))(MuiDialogContent);
